import { createAsyncThunk } from "@reduxjs/toolkit"

import { errorSave } from "../../../../redux/errors.slice"
import { type BasePagination } from "../../../../types/api.ts"
import { unknownError } from "../../../../utils/handlers/handle-error"
import * as services from "../../api/project-subcontractors.services"
import { type ProjectSubcontractor } from "../../types/project-subcontractors.types.tsx"
import { projectSliceName } from "../project.constants.ts"
import { type ProjectSubcontractorFilters } from "../project.types.ts"

export const fetchProjectSubcontractors = createAsyncThunk<
  {
    isMore: boolean
    data: BasePagination<ProjectSubcontractor>
  },
  {
    isMore: boolean
    params: ProjectSubcontractorFilters & { project_id: string }
  }
>(
  `${projectSliceName}/fetchProjectSubcontractors`,
  async ({ isMore, params }, { dispatch, rejectWithValue }) => {
    const response = await services.getProjectSubcontractors(params)

    if (!response.ok) {
      dispatch(errorSave(response?.data?.details || unknownError))
      return rejectWithValue(response.data)
    }

    return {
      isMore,
      data: response.data as BasePagination<ProjectSubcontractor>
    }
  }
)
